import React from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Container,
  Grid,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Divider,
  CircularProgress,
} from "@mui/material";
import { Helmet } from "react-helmet";
import InputLabel from "@mui/material/InputLabel";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles((theme) => ({
  btncenter: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 30px",
    paddingLeft: 10,
  },
}));

export default function CustomizationRequest() {
  const vertical = 'top';
  const horizontal = 'center';
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const maxLength = 12; // Maximum length for mobile number
  const [emailError, setEmailError] = React.useState(false);
  const [mobileError, setMobileError] = React.useState(false);

  const [state, setState] = React.useState({
    requestname: "",
    mobilenumber: "",
    emailid: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
    // Check email validation on change
    validateEmail(value);
  };

  const handleMobilenumberChange = (e) => {
    const { name, value } = e.target;
    // Validate if the value is a number and the length does not exceed 12
    if (!isNaN(value) && value.length <= 10) {
      setState({
        ...state,
        [name]: value,
      });

      // Check mobile number length and set error if less than 10
      if (value.length < 10) {
        setMobileError(true);
      } else {
        setMobileError(false);
      }
    }
  };

  const validateEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(email));
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    // console.log("RequestName", state.requestname);
    // console.log("typeOf", typeof state.requestname);
    let validatestatus = false
    const details = {
      name: state.requestname,
      mobilenumber: state.mobilenumber,
      emailid: state.emailid,
      description: state.description
    }

    if (state.requestname.length <= 0) {
      setOpen(true);
      setOpen1(false);
      setOpen2(false);
      setOpen4(false);
    }
    else if (state.mobilenumber.length < 10 || mobileError == true) {
      setOpen2(false);
      setOpen(false);
      setOpen1(true);
      setOpen4(false);
    }
    else if (state.emailid.length <= 0 || emailError == true) {
      setOpen(false);
      setOpen1(false);
      setOpen2(true);
      setOpen4(false);
    }
    else if (state.description.length <= 0) { 
      setOpen(false);
      setOpen1(false);
      setOpen2(false);
      setOpen4(true);
    }
    else {
      setOpen(false);
      setOpen1(false);
      setOpen2(false);
      setOpen4(false);
      validatestatus = true;
    }
    if (validatestatus) {
      // console.log("status", validatestatus);

      fetch(`${process.env.REACT_APP_API_URL}/api/customizationrequest/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(details),
      })
        .then((resp) => resp.json())
        .catch((error) => {
          console.error(error);
        });
        setOpen3(true);
        window.location.href = "/app/personalizedlist";
    }
  };

  const handleCacheClear = (e) => {
    e.preventDefault();
    setState({
      requestname: "",
      mobilenumber: "",
      emailid: "",
      description: "",
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMobileClose = () => {
    setOpen1(false);
  };

  const handleDescriptionClose = () => {
    setOpen4(false);
  };

  const handleEmailClose = () => {
    setOpen2(false);
  };

  const handleSubmitClose = () => {
    setOpen3(false);
    // window.location.reload();
    // window.location.href = "/app/personalizedlist";
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">FIELD REQUIRED</DialogTitle>
        <DialogContent dividers>
          <Alert severity="error">
            <Typography color="textSecondary" gutterBottom variant="h6">
              Please enter your Name
            </Typography>
          </Alert>
        </DialogContent>

        {/* <DialogContent>
          <DialogContentText>
            Please enter the Lab Name
          </DialogContentText>
          <br />
          <br />
        </DialogContent> */}
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleClose} color="primary" sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open1}
        onClose={handleMobileClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">FIELD REQUIRED</DialogTitle>
        <DialogContent dividers>
          <Alert severity="error">
            <Typography color="textSecondary" gutterBottom variant="h6">
              Please validate your mobile number
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleMobileClose} color="primary" sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open2}
        onClose={handleEmailClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">FIELD REQUIRED</DialogTitle>
        <DialogContent dividers>
          <Alert severity="error">
            <Typography color="textSecondary" gutterBottom variant="h6">
              Please validate your Email id
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleEmailClose} color="primary" sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={open3}
        onClose={handleSubmitClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Thank you! Your request has been submitted. Team will get in touch with you soon.</DialogTitle>
        <DialogActions>
          <Button onClick={handleSubmitClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog> */}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open3}
        // onClose={handleClose}
        key={vertical + horizontal}
        autoHideDuration={2000} // Show Snackbar for 3 seconds
        style={{ width: '750px', height: '100px' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          style={{ backgroundColor: "#38761d", fontSize: "20px" }}
            severity="info"
            autoHideDuration={2000} // Show Snackbar for 3 seconds
          // onClose={handleClose}
        >
          Thank you! Your request has been submitted. Team will get in touch with you soon.
        </MuiAlert>
      </Snackbar>
      <Dialog
        open={open4}
        onClose={handleDescriptionClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">FIELD REQUIRED</DialogTitle>
        <DialogContent dividers>
          <Alert severity="error">
            <Typography color="textSecondary" gutterBottom variant="h6">
              Please enter description
            </Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleDescriptionClose} color="primary" sx={{ borderRadius: '50px' }}>
                OK
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <Card>
            <CardHeader
              title="Personalized Request"
              action={
                <Grid container spacing={1}>
                  {/* <Grid item xs={4}></Grid> */}
                  <Grid item xs={4}>
                    <Tooltip title="Clear form">
                      <span>
                        <Button
                      startIcon={<ClearIcon />}
                      variant="contained"
                      // color="primary"
                      // fullWidth
                      onClick={handleCacheClear}
                      // disabled={estimationcount.total_price > 0 ? false : true}
                          sx={{ borderRadius: '50px' }}
                        >
                          Clear
                        </Button>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              }
            />
            <Divider />
            <CardContent>
              <Grid container justify="center" spacing={3}>
                <Grid container spacing={3} item justify="flex-end" xs={12}>
                  <Grid item xs={4}>
                    <InputLabel>
                      Name
                      <small style={{ paddingLeft: "10px" }}>required</small>
                      <small style={{ color: "red" }}>*</small>
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="requestname"
                      id="requestname"
                      onChange={handleChange}
                      value={state.requestname}
                      required
                      size="small"
                      autoComplete="name"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel>
                      Mobile Number
                      <small style={{ paddingLeft: "10px" }}>required</small>
                      <small style={{ color: "red" }}>*</small>
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="mobilenumber"
                      id="mobilenumber"
                      value={state.mobilenumber}
                      onChange={handleMobilenumberChange}
                      required
                      error={mobileError}
                      helperText={mobileError ? "Invalid mobile number" : ""}
                      autoComplete="mobilenumber"
                      inputProps={{
                        maxLength: maxLength,
                        min: "0",
                        max: "999999999999",
                      }} // Max length and max value
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputLabel>
                      Email
                      <small style={{ paddingLeft: "10px" }}>required</small>
                      <small style={{ color: "red" }}>*</small>
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="emailid"
                      id="emailid"
                      value={state.emailid}
                      onChange={handleEmailChange}
                      required
                      error={emailError}
                      helperText={emailError ? "Invalid email format" : ""}
                      autoComplete="family-name"
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}></Grid>
                </Grid>
                <Divider />
                <Grid container spacing={3} item justify="flex-end" xs={12}>
                  <Grid item xs={12}>
                  <InputLabel>
                      Description
                      <small style={{ paddingLeft: "10px" }}>required</small>
                      <small style={{ color: "red" }}>*</small>
                    </InputLabel>
                    <TextField
                      fullWidth
                      name="description"
                      id="description"
                      value={state.description}
                      onChange={handleChange}
                      required
                      autoComplete="family-name"
                      multiline
                      rows={5}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
            <Grid item xs={12}>
              <br />
              <Divider />
              <br />
            </Grid>
            <CardContent>
              <div className={classes.btncenter}>
                <Tooltip title="Submit customization request">
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes}
                      onClick={handleSubmitClick}
                      sx={{ borderRadius: '50px' }}
                    >
                      Submit
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </div>
  );
}
